/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Gallery_DescriptionInputs */

const en_meta_showcase_gallery_description = /** @type {(inputs: Meta_Showcase_Gallery_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand-aware property photo gallery with category filters, lightbox and instant theming: the gallery pattern we ship on hotel booking websites.`)
};

const lv_meta_showcase_gallery_description = /** @type {(inputs: Meta_Showcase_Gallery_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zīmolam pielāgota viesnīcas foto galerija ar kategoriju filtriem, pilnekrāna skatītāju un tūlītēju tēmas maiņu — tāda, kādu veidojam viesnīcu mājaslapām.`)
};

/**
* | output |
* | --- |
* | "Brand-aware property photo gallery with category filters, lightbox and instant theming: the gallery pattern we ship on hotel booking websites." |
*
* @param {Meta_Showcase_Gallery_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_gallery_description = /** @type {((inputs?: Meta_Showcase_Gallery_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Gallery_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_gallery_description(inputs)
	return en_meta_showcase_gallery_description(inputs)
});